import easyMapsTheme from "./easyMapsTheme";
import easyReportTheme from "./easyReportTheme";
import mainTheme from "./mainTheme";

export const myTheme = (colorMode) => mainTheme(colorMode);

export const themeEasyMaps = (colorMode) => easyMapsTheme(colorMode);

export const themeEasyReport = (colorMode) => easyReportTheme(colorMode);
